<div class="new-dropdown-container">
    <!-- New button -->
    @if(universalService.activeRepo != 'enterprise'){
      <button (click)="toggleDropdown()" class="new-button" [ngClass]="(!universalService.allowUpload && router.url.includes('/teamfolders') || (universalService.showFeaturesForEntUsers &&!universalService.allowUpload && router.url.includes('/shared/'))) ? 'disabled' : ''">
        <span class="Neueaddfilefilled"></span>New
      </button>
    }
    @if(universalService.activeRepo == 'enterprise'){
      <button (click)="newTeamFolder()" class="new-button">
        <span class="Neueaddfilefilled"></span>Team Folder
      </button>
    }
  
    <!-- Dropdown Menu -->
    @if(dropdownVisible){
        <div class="dropdown-menu" [@fadeInOut] >
            <button class="upload-files" (click)="uploadFile()" [ngClass]="(!universalService.allowUpload && router.url.includes('/teamfolders') || !universalService.allowUpload && router.url.includes('/shared/')) ? 'disabled' : ''">
              <span class="NeueFile_Uploading buttonIcon"></span>Upload File(s)</button>
            <button class="upload-folder" (click)="uploadFolder()" [ngClass]="(!universalService.allowUpload && router.url.includes('/teamfolders') || !universalService.allowUpload && router.url.includes('/shared/') || (universalService.currentAlbum && router.url.includes(universalService.currentAlbum.boardKey))) ? 'disabled' : ''">
              <span class="NeueFolderFilled buttonIcon"></span>Upload Folder</button>
            <button class="new-folder" (click)="newFolder()" [ngClass]="(!universalService.allowUpload && router.url.includes('/teamfolders') || !universalService.allowUpload && router.url.includes('/shared/') || (universalService.currentAlbum && router.url.includes(universalService.currentAlbum.boardKey))) ? 'disabled' : ''">
              <span class="NeueAddFolderFilled buttonIcon"></span>New Folder</button>
            @if(!universalService.showFeaturesForEntUsers){
              <button class="new-album" (click)="newAlbum()" [ngClass]="(universalService.currentAlbum && router.url.includes(universalService.currentAlbum.boardKey)) ? 'disabled' : ''"><span class="NeueImageFilled buttonIcon"></span>New Album</button>
            }
        </div>
    }
  </div>